import React from 'react';
import { TrashButton, LoadingIcon, ScrollDiv } from '_components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { notesPendingActionActions } from '_actions';
import { NotesPendingActionListItem } from 'MessageCenter/NotesPendingAction'
import styles from './List.module.css'

class NotesPendingActionList extends React.Component {

    getListHeader() {
        if (this.props.loading === true)
            return (<LoadingIcon size="small" />);
        else if (this.props.deleting === true)
            return (<LoadingIcon size="small" />);
        else if (this.props.messages && Object.keys(this.props.messages).length > 0)
            return (<span className={styles.delete_all_button_pointer} onClick={() => this.props.deleteAllMsgs(this.props.approvedNonos)}>
                <TrashButton size="medium" title='Delete All Approved Messages' />
            </span>);
        else if (this.props.messages && Object.keys(this.props.messages).length === 0)
            return (<div style={{ fontStyle: 'italic' }}>No Messages</div>);
        else
            return (<span />);
    }

    render() {
        return (
            <div>
                <div className={styles.delete_all_button_container}>
                    {this.getListHeader()}
                </div>
                <ScrollDiv divId={'MC_NOTES_PENDING_ACTION'} className={styles.message_list}>
                    {Object.keys(this.props.messages)
                        .sort((a, b) => new Date(this.props.messages[b].noteDate) - new Date(this.props.messages[a].noteDate))
                        .map(key => {
                            const message = this.props.messages[key];
                            return <NotesPendingActionListItem
                                key={message.id}
                                id={message.id}
                            />
                        })

                    }
                </ScrollDiv>
            </div>
        );
    }
}


function mapStateToProps(state) {
    let approvedTypes = [1, 3, 5];
    let approvedNonos = Object.keys(state.entities.notesPendingAction)
        .filter(x => approvedTypes.includes(state.entities.notesPendingAction[x].notificationType))
        .map(x => state.entities.notesPendingAction[x].NONO);

    let messages = Object.keys(state.entities.notesPendingAction)
        .sort((a, b) =>
            new Date(state.entities.notesPendingAction[b].msgDate).getTime() - new Date(state.entities.notesPendingAction[a].msgDate).getTime()
        )
        .map(x => state.entities.notesPendingAction[x]);

    return {
        approvedNonos,
        messages,
        loading: state.ui.notesPendingAction.loading,
        deleting: state.ui.notesPendingAction.deleting
    };
}


function mapDispatchToProps(dispatch) {
    return {
        deleteAllMsgs: bindActionCreators(notesPendingActionActions.deleteAll, dispatch)
    };
}

const connectedNotesPendingActionList = connect(mapStateToProps, mapDispatchToProps)(NotesPendingActionList);
export { connectedNotesPendingActionList as NotesPendingActionList };